
export default {
  init() {
    var variables = {
      currentQuestion: 0,
      questionsNumber: 10,
    };
    
    var utils = {
      adjustViewSize: function() {
        var adminBarHeight = jQuery('#wpadminbar').outerHeight();
        var navBarHeight = jQuery('#header').outerHeight();
        var screenHeight = jQuery(window).height();
        jQuery('.main').height(screenHeight - navBarHeight - adminBarHeight);
      },

      setButtonsVisibility: function(questionsNumber) {
        jQuery('#send-buttons').css('display', variables.currentQuestion == questionsNumber - 1 ? 'flex' : 'none');
        jQuery('#next-buttons').css('display', variables.currentQuestion == questionsNumber - 1 ? 'none' : 'flex');
        jQuery('#prev-arrow').css('visibility', variables.currentQuestion == 0 ? 'hidden' : 'visible');
      },

      setButtonsEnable: function(enable) {
        jQuery('#send-buttons').css('visibility', enable ? 'visible' : 'hidden');
        jQuery('#next-buttons').css('visibility', enable ? 'visible' : 'hidden');
        jQuery('#prev-arrow').css('visibility', enable ? 'visible' : 'hidden');
      },

      setDots: function() {
        jQuery('.fa-circle').each(function(index) {
          if (index == variables.currentQuestion) {
            jQuery(this).attr('class', 'fas fa-circle normal');
          } else if (index > variables.currentQuestion) {
            jQuery(this).attr('class', 'far fa-circle tiny');
          } else {
            jQuery(this).attr('class', 'fas fa-circle tiny');
          }
        })
      },

      getCookie: function(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      },

      getUrlParam: function(name) {
        var url = location.href;

        var regex = new RegExp('[?&]' + name + '=([^&#/]*)/?');
        var results = regex.exec(url);
        return results == null ? null : results[1];
      },
    };

    var navigator = {
      goToQuestion: function(questionsNumber) {
        jQuery('#poll-container').css('transform', 'translateX(' + variables.currentQuestion * -100 + '%)');
        utils.setButtonsEnable(false);
        utils.setDots();
        setTimeout(() => {
          utils.setButtonsEnable(true);
          utils.setButtonsVisibility(questionsNumber);
        }, 800);
      },

      showFinishMessage: function(ok, questionsNumber) {
        jQuery('#end-item').css('display', 'flex');
        jQuery('#end-item-ok').css('display', ok ? 'flex' : 'none');
        jQuery('#end-item-ko').css('display', ok ? 'none' : 'ok');
        jQuery('#poll-dots').css('display', 'none');
        jQuery('#send-buttons').css('display', 'none');
        jQuery('#next-buttons').css('display', 'none');
        jQuery('#prev-arrow').css('display', 'none');
        jQuery('#poll-container').css('transform', 'translateX(' + questionsNumber * -100 + '%)');
      },
    };

    var helpers = {
      saveLanguageAndReload: function() {
        helpers.saveLanguage();
        location.reload();
      },

      saveLanguage: function() {
        document.cookie = 'poll_language=' + jQuery('#language-select').val();
      },

      saveProfession: function() {
        document.cookie = 'poll_profession=' + jQuery('#profession-select').val();
      },

      initSatisfactionPoll: function(questionsNumber) {
        setTimeout(() => {
          jQuery('#start-item').css('display', 'none');
          jQuery('#start-button').css('display', 'none');
          jQuery('#poll-dots').css('display', 'flex');
          utils.setButtonsVisibility(questionsNumber);
        }, 500);
      },

      finishSatisfactionPoll: function(questionsNumber) {
        let valid = validator.isValid(questionsNumber);
        if(valid.isValid) {
          let elements = jQuery('#satisfaction-poll').serializeArray();
          let data = {
            'event': 'FORM_' + utils.getUrlParam('idForm'),
            'language': utils.getCookie('poll_language'),
            'profession': parseInt(utils.getCookie('poll_profession')),
            'ip': utils.getCookie('poll_ip'),
          };
          let answers = [];
          jQuery.each(elements, function(index, element) {
            let questionType = element.name.split('-')[0];
            let question = element.name.split('-')[1];
            let answer = element.value;
            if (questionType == 'textarea') {
              answers.push({
                'id': question,
                'text': answer,
              });
            } else {
              answers.push({
                'id': question,
                'answer': answer,
              });
            }
          });
          data.questions = answers;
    
          jQuery.ajax({
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json',
            success: function(response) {
              navigator.showFinishMessage(response.status, variables.questionsNumber);
            },
            error: function(response) {
              navigator.showFinishMessage(response.status, variables.questionsNumber);
            },
            processData: false,
            type: 'POST',
            url: '/wp-json/satisfaction-poll/complete',
          });
        } else {
          variables.currentQuestion = valid.number - 1;
          jQuery('#satisfaction-modal-body').text(valid.number);
          jQuery('#satisfaction-modal').modal('show'); 
          jQuery('#satisfaction-modal').on('hidden.bs.modal', function () {
            navigator.goToQuestion(variables.questionsNumber);
            jQuery('#submitButton').attr('disabled', false);
          });
        }
      },
    };

    var validator = {
      isValid: function(questionsNumber) {
        let valid = {
          'isValid': true,
          'number': null,
        };
        for (let index = 1; index <= questionsNumber; index++) { // index = numero de la pregunta
          if (jQuery('textarea[data=textarea-' + index + ']').length == 0) { // si no es textarea es obligatorio
            if (jQuery('input[data=switch-' + index + ']:checked').length == 0) {
              valid.isValid = false;
              valid.number = index;
              return valid;
            }
          }
        }
        return valid;
      },

      checkProfession: function() {
        return utils.getCookie('poll_profession') != undefined && utils.getCookie('poll_profession') != '';
      },

      checkLanguage: function() {
        return utils.getCookie('poll_language') != undefined && utils.getCookie('poll_language') != '';
      },
    };

    var translator = {
      translations: {
        'es': {
          'title': 'Tu opinión nos importa',
          'professor': 'Profesor',
          'date': 'Fecha',
          'start': 'Comenzar',
          'profession': 'Elige una profesión',
          'next': 'Siguiente pregunta',
          'send': 'Enviar encuesta',
        },
        'en': {
          'title': 'Your opinion matters',
          'professor': 'Professor',
          'date': 'Date',
          'start': 'Start',
          'profession': 'Select a profession',
          'next': 'Next question',
          'send': 'Send a survey',
        },'pt': {
          'title': 'Sua opinião é importante para nós',
          'professor': 'Professora',
          'date': 'Data',
          'start': 'Começar',
          'profession': 'Escolha uma profissão',
          'next': 'Seguinte pergunta',
          'send': 'Envie uma pesquisa',
        },
      },
      translate: function(key) {
        var language = utils.getCookie('poll_language');
        if (!language) language = 'es';
        return this.translations[language][key];
      },
    };

    jQuery('#next-buttons').on('click', function() {
      if (variables.currentQuestion < variables.questionsNumber - 1) {
        variables.currentQuestion++;
        navigator.goToQuestion(variables.questionsNumber);
      } else {
        variables.currentQuestion = 0;
        navigator.goToQuestion(variables.questionsNumber);
      }
    });

    jQuery('#prev-arrow').on('click', function() {
      if (variables.currentQuestion >= 1) {
        variables.currentQuestion--;
        navigator.goToQuestion(variables.questionsNumber);
      } else {
        variables.currentQuestion = 0;
        navigator.goToQuestion(variables.questionsNumber);
      }
    });

    jQuery('.fa-circle').on('click', function() {
      variables.currentQuestion = parseInt(jQuery(this).attr('name').split('-')[1]);
      navigator.goToQuestion(variables.questionsNumber);
    });
    
    jQuery('#start-button').on('click', function() {
      if (validator.checkProfession()) {
        helpers.saveLanguageAndReload();
      } else {
        jQuery('#profession-select').next().css('border', '2px solid red');
      }
    });

    jQuery('#satisfaction-poll').submit(function (e) {
      e.preventDefault();
      jQuery('#submitButton').attr('disabled', true);
      helpers.finishSatisfactionPoll(variables.questionsNumber);
    });

    utils.adjustViewSize();
    utils.setDots(0);
    if(validator.checkLanguage() && validator.checkProfession()) {
      helpers.initSatisfactionPoll(variables.questionsNumber);
    }

    //Traducciones
    jQuery('[translate]').each(function(index, item) {
      jQuery(item).append(translator.translate(jQuery(item).attr('translate')));
    });

    jQuery('#language-select').change(function() {
      helpers.saveLanguage();
      jQuery('[translate]').each(function(index, item) {
        jQuery(item).html(translator.translate(jQuery(item).attr('translate')));
      });
    });

    jQuery('#profession-select').change(function() {
      helpers.saveProfession();
    });

    if(!validator.checkLanguage()) {
      jQuery('#language-select').change();
    }

    if(!validator.checkProfession()) {
      jQuery('#language-select').change();
    }
  },
}


// WEBPACK FOOTER //
// resources/assets/scripts/routes/satisfaction-poll.js